/**
 * Client-side gzip → base64. Browsers don't compress request bodies, so we do
 * it ourselves via the native CompressionStream (Chromium/modern browsers). The
 * backend stores the result as-is (`Content-Encoding: gzip`) without ever
 * decompressing it.
 */

export function supportsCompression(): boolean {
  return typeof CompressionStream !== "undefined";
}

export async function gzipToBase64(text: string): Promise<string> {
  const stream = new Blob([text])
    .stream()
    .pipeThrough(new CompressionStream("gzip"));
  const buf = await new Response(stream).arrayBuffer();
  return bytesToBase64(new Uint8Array(buf));
}

function bytesToBase64(bytes: Uint8Array): string {
  // Chunked to avoid arg-count limits on very large arrays.
  let binary = "";
  const CHUNK = 0x8000;
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}
